export const profits = {
  'backoffice.profits.accountsSummary.title': 'Hesap Kâr Özeti',
  'backoffice.profits.accountsSummary.subtitle': 'Tüm yatırım hesaplarınızdaki kâr performansına genel bakış',
  'backoffice.profits.accountsHistory.title': 'Hesap Kâr Geçmişi',
  'backoffice.profits.accountsHistory.subtitle': 'Yatırım hesaplarınız için detaylı geçmiş kâr verileri',
  'backoffice.profits.commissionsSummary.title': 'Komisyon Özeti',
  'backoffice.profits.commissionsSummary.subtitle': 'Referans komisyonlarınıza ve kazançlarınıza genel bakış',
  'backoffice.profits.commissionsHistory.title': 'Komisyon Geçmişi',
  'backoffice.profits.commissionsHistory.subtitle': 'Komisyon kazançları ve işlemlerin detaylı geçmişi',
  'backoffice.profits.commissionsPaymentHistory.title': 'Komisyon Ödeme Geçmişi',
  'backoffice.profits.commissionsPaymentHistory.subtitle': 'Tüm komisyon ödemelerini ve çekme geçmişini takip edin',
  'backoffice.profits.common.loading': 'Kâr verileri yükleniyor...',
  'backoffice.profits.common.error': 'Kâr bilgileri yüklenirken hata',
  'backoffice.profits.common.noData': 'Kâr verisi mevcut değil',
  'backoffice.profits.common.comingSoon': 'Bu özellik yakında gelecek',
  'backoffice.profits.common.placeholder': 'Kâr detayları uygulandığında burada görüntülenecek',
  'backoffice.profits.lifetime.title': 'Ömür Boyu Hesap Kârları',
  'backoffice.profits.lifetime.totalProfit': 'Toplam Ömür Boyu Kâr',
  'backoffice.profits.lifetime.accountProfit': 'Hesap Kârı',
  'backoffice.profits.lifetime.programProfit': 'Program Kârı',
  'backoffice.profits.lastMonth.title': 'Geçen Ay Hesap Kârları',
  'backoffice.profits.lastMonth.totalProfit': 'Toplam Geçen Ay Kârı',
  'backoffice.profits.lastMonth.accountProfit': 'Hesap Kârı',
  'backoffice.profits.lastMonth.programProfit': 'Program Kârı',
  'backoffice.profits.overtime.title': 'Zaman İçinde Hesap Kârları',
  'backoffice.profits.overtime.chartTitle': 'Kâr Geçmişi (Son 12 Ay)',
  'backoffice.profits.breakdown.title': 'Hesaba Göre Dağılım',
  'backoffice.profits.breakdown.accountNumber': 'Hesap Numarası',
  'backoffice.profits.breakdown.broker': 'Broker',
  'backoffice.profits.breakdown.balance': 'Bakiye',
  'backoffice.profits.breakdown.accountProfit': 'Hesap Kârı',
  'backoffice.profits.breakdown.programProfit': 'Program Kârı',
  'backoffice.profits.breakdown.totalProfit': 'Toplam Kâr',
  'backoffice.profits.breakdown.noAccounts': 'Hesap bulunamadı',
  'backoffice.profits.history.filters.account': 'Hesap',
  'backoffice.profits.history.filters.allAccounts': 'Tüm Hesaplar',
  'backoffice.profits.history.filters.dateFrom': 'Başlangıç Tarihi',
  'backoffice.profits.history.filters.dateTo': 'Bitiş Tarihi',
  'backoffice.profits.history.filters.apply': 'Filtreleri Uygula',
  'backoffice.profits.history.filters.reset': 'Sıfırla',
  'backoffice.profits.history.table.title': 'Kâr Geçmişi',
  'backoffice.profits.history.table.account': 'Hesap',
  'backoffice.profits.history.table.period': 'Dönem',
  'backoffice.profits.history.table.accountProfit': 'Hesap Kârı',
  'backoffice.profits.history.table.exportCSV': 'CSV Dışa Aktar',
  'backoffice.profits.history.pagination.showing': 'Gösterilen',
  'backoffice.profits.history.pagination.of': '/',
  'backoffice.profits.history.pagination.results': 'sonuç',
  'backoffice.profits.history.pagination.page': 'Sayfa',
  'backoffice.profits.history.pagination.previous': 'Önceki',
  'backoffice.profits.history.pagination.next': 'Sonraki',
  'backoffice.profits.history.pagination.loadMore': 'Daha Fazla Yükle',
  'backoffice.profits.commissions.lifetime.title': 'Ömür Boyu Komisyonlar',
  'backoffice.profits.commissions.lastMonth.title': 'Geçen Ay Komisyonları',
  'backoffice.profits.commissions.balance.title': 'Mevcut Bakiye',
  'backoffice.profits.commissions.balance.lastUpdated': 'Son güncelleme:',
  'backoffice.profits.commissions.paid.title': 'Toplam Ödenen',
  'backoffice.profits.commissions.overtime.title': 'Zaman İçinde Komisyonlar',
  'backoffice.profits.commissionsHistory.filters.level': 'Kademe',
  'backoffice.profits.commissionsHistory.filters.allLevels': 'Tüm Kademeler',
  'backoffice.profits.commissionsHistory.filters.levelNumber': 'Kademe {{level}}',
  'backoffice.profits.commissionsHistory.table.title': 'Komisyon Geçmişi',
  'backoffice.profits.commissionsHistory.table.date': 'Tarih',
  'backoffice.profits.commissionsHistory.table.level': 'Kademe',
  'backoffice.profits.commissionsHistory.table.levelCompany': 'Şirket',
  'backoffice.profits.commissionsHistory.table.levelLeftover': 'Kalan',
  'backoffice.profits.commissionsHistory.table.commission': 'Komisyon',
  'backoffice.profits.commissionsHistory.table.levelNumber': 'Kademe {{level}}',
  'backoffice.profits.commissionsPaymentHistory.filters.status': 'Durum',
  'backoffice.profits.commissionsPaymentHistory.filters.allStatuses': 'Tüm Durumlar',
  'backoffice.profits.commissionsPaymentHistory.filters.paymentMethod': 'Ödeme Yöntemi',
  'backoffice.profits.commissionsPaymentHistory.filters.allPaymentMethods': 'Tüm Ödeme Yöntemleri',
  'backoffice.profits.commissionsPaymentHistory.filters.crypto': 'Kripto',
  'backoffice.profits.commissionsPaymentHistory.filters.bank': 'Banka Havalesi',
  'backoffice.profits.commissionsPaymentHistory.table.title': 'Komisyon Ödeme Geçmişi',
  'backoffice.profits.commissionsPaymentHistory.table.date': 'Tarih',
  'backoffice.profits.commissionsPaymentHistory.table.paymentMethod': 'Ödeme Yöntemi',
  'backoffice.profits.commissionsPaymentHistory.table.status': 'Durum',
  'backoffice.profits.commissionsPaymentHistory.table.amount': 'Tutar',
  'backoffice.profits.commissionsPaymentHistory.table.exportCSV': 'CSV Dışa Aktar',
  'backoffice.profits.commissionsPaymentHistory.status.paid': 'Ödendi',
  'backoffice.profits.commissionsPaymentHistory.status.completed': 'Tamamlandı',
  'backoffice.profits.commissionsPaymentHistory.status.pending': 'Beklemede',
  'backoffice.profits.commissionsPaymentHistory.status.cancelled': 'İptal Edildi',
  'backoffice.profits.commissionsPaymentHistory.status.failed': 'Başarısız',
  'backoffice.profits.commissionsPaymentHistory.status.rejected': 'Reddedildi',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.crypto': 'Kripto',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.bank': 'Banka Havalesi',
  'backoffice.profits.commissionsPaymentHistory.paymentMethod.unknown': 'Bilinmiyor'
};
